import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { Employee } from 'src/app/core/data/entities';

@Component({
    selector: 'app-employee-search',
    templateUrl: './employee-search.component.html',
    styleUrls: ['./employee-search.component.scss'],
    standalone: false
})
export class EmployeeSearchComponent implements OnInit {
    employees: any;
    showActive: boolean = true;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        private router: Router,
        private auth: AuthenticationService,
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
        );
    }

    async toggleShowActive() {
        this.showActive = !this.showActive;
        await this.getData();
    }

    async getData() {
        this.employees = await this.uow.getActiveEmployees(!this.showActive) as Employee[];
        console.log(this.employees);
    }

    search() {}
    clear() {}

    selectionChange(e) {}

    async open(id?: number) {
        console.log(id);
        this.router.navigate(['admin/employees/' + (!!id ? id : 'new')]);
    }
    async rowDoubleClick(e) {
        if (!e.data) return;
        await this.open(e.data.id);
    }
}
